import React from "react";
import "./CardSlider.css";


export default function CardSlider(){
  return(
    <div className="slider">
      <h1 className="card_title1">Our services</h1>
   
  
      <div className="slides">
        <div className="slide-1">
          <h1 className="card_title">Our project mission👉</h1>
          <p className="card_description">Our project aims to increase students' productivity through ALU's new learning model. Our student-oriented platform will allow students to have organized schedules for their classes, assignment deadlines, and other school events</p>
        </div>
        <div className="slide-2">
          <h1 className="card_title">👈Deadlines reminder👉</h1>
          <p className="card_description">You won’t miss deadlines again.</p>
        </div>
        
        
        
     
      
      </div>
      <p className="card_description">Join HistoVerse today and discover the power of AI-generated history videos and social media collaboration.</p>
      <div className="btn">
        <button className="btn_slider"><a href="https://login-kakaymi10.vercel.app" target="_blank">Try HisBot</a></button>
        <button className="btn_slider"><a href="https://login-kakaymi10.vercel.appl" target="_blank">try HisBook</a></button>
      </div>
    </div>

  )
}